const extraActivityRouterName = ['/activity221025', '/intro', '/activity230103']

export default extraActivityRouterName
